import { ExpandableParagraph, Typography } from 'omakase';
import { consumer, core } from '@tock/coretypes';
import { isOrderVariety } from '@tock/shared/utils/offerings';

type Props = {
  business?: consumer.IBusinessConfig | null;
  purchase?: core.PastPurchase;
  confirmationText?: string;
};

export const ReceiptMessage = (props: Props) => {
  if (
    props.confirmationText &&
    props.purchase &&
    props.business &&
    props.purchase.originatedAt !== 'VISIT_EDIT' &&
    !props.purchase.cancelledOrRefunded &&
    !isOrderVariety(props.purchase.ticketTypeVariety)
  ) {
    return (
      <div>
        <p className="ConsumerCheckout-sectionHeading">
          <Typography component="span" variant="heading04" data-testid="receipt-business-message">
            Message from {props.business.name}
          </Typography>
        </p>
        <ExpandableParagraph paragraphText={props.confirmationText} cutoffLength={200} />
      </div>
    );
  }

  return null;
};
